<template>
  <div>
    <section>
      <div :class="isLoading ? 'pt-6' : ''">
        <Skeleton :loading="isLoading" lineHeight="2"/>
      </div>
      <div class="mt-3 flex flex-col">
        <div
          v-for="method in paymentMethods" :key="method.id"
          class="py-3 h-16 flex justify-between items-center border-b">
          <input type="radio" :value="method.id" v-model="selectedPaymentMethod" role="checkbox" v-if="radioButtons">
          <card :card="method" @deleted="getPaymentMethods()" />
          <button class="hover:text-b2c-red-300 w-4 mr-2"
          @click="addNewCard=false" title="delete" v-if="addNewCard">
          </button>
        </div>
        <button class="p-2 mt-6 shadow-md rounded-md hover:bg-b2c-red-300 hover:text-white w-1/2 lg:w-1/3 text-xs md:text-md"
          @click="addNewPaymentMethod()" v-if="!notShowAddButton && !isLoading">
            {{$t('stripe.add')}}
        </button>
      </div>
    </section>
    <div v-if="addNewCard">
      <button class="hover:text-b2c-red-300 flex justify-end w-full"
        @click="addNewCard=false" title="delete" >
          <close-icon />
      </button>
      <stripe-component :intent="intent"
        @updated-payment-method="rechargePaymentMethods()" />
    </div>
  </div>
</template>

<script>
import StripeComponent from '@/components/Stripe.vue';
import Card from '@/components/graphics/Card.vue';
import { mapGetters } from 'vuex';
import { Skeleton } from '@/components/Skeleton/src/index';
import { getCustomerCards, getCustomerSetupIntent } from '@/services/OrdersService';
import CloseIcon from '../graphics/CloseIcon.vue';

export default {
  props: ['radioButtons', 'notShowAddButton', 'value', 'add'],

  data() {
    return {
      startAdding: !!this.add,
      addNewCard: false,
      intent: null,
      paymentMethods: [],

      selectedPaymentMethod: this.value,

      idToDelete: '',

      isLoading: false,
    };
  },

  components: {
    StripeComponent,
    Card,
    CloseIcon,
    Skeleton,
  },

  watch: {
    deletedPaymentMethod() {
      this.getPaymentMethods();
    },

    selectedPaymentMethod() {
      this.$emit('input', this.selectedPaymentMethod);
    },
  },

  computed: {
    ...mapGetters({
      customer: ['auth/customer'],
      deletedPaymentMethod: ['cart/deletedPaymentMethod'],
    }),
  },

  mounted() {
    if (this.customer) {
      this.getPaymentMethods();
    }
  },

  methods: {
    getPaymentMethods() {
      this.isLoading = true;
      this.paymentMethods = [];
      getCustomerCards(this.customer.id, 'card').then((response) => {
        this.paymentMethods = response.data;
        this.isLoading = false;
        this.selectedPaymentMethod = this.paymentMethods.length > 0 ? this.paymentMethods[0].id : null;
        if (this.addNewCard) {
          this.addNewCard = false;
        }
        if (this.startAdding) {
          this.addNewPaymentMethod();
          this.startAdding = false;
        }
      }).catch((error) => {
        this.isLoading = false;
        this.checkRoutingAuthentication(error);
      });
    },

    addNewPaymentMethod() {
      this.addNewCard = true;
      getCustomerSetupIntent(this.customer.id).then((response) => {
        this.intent = response.data.intent;
      });
    },

    rechargePaymentMethods() {
      this.getPaymentMethods();
    },

    setLoadingClass(id) {
      if (this.isLoading && this.idToDelete === id) return 'loader';
      return '';
    },

  },
};
</script>
